import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { themeOptions } from './theme';
import { LicenseInfo } from '@mui/x-license-pro';

import axios from 'axios';

LicenseInfo.setLicenseKey('472f00a3a6e9db5c73605850bea92e66Tz02MjAyMCxFPTE3MTA0MzM5NDc4NTEsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y');

axios.defaults.withCredentials = true

const theme = createTheme(themeOptions);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
